import api from "./api";

/**
 * @file patient-programs.js
 * @description "Mis programas" del paciente. De cara al paciente son
 *   "programas", pero técnicamente son los **protocolos/treatments** que tiene
 *   asignados (ej. "Hipertensión") — de ahí salen sus tareas. Se derivan de los
 *   episodios del paciente (`GET /episodes/patients/:id/`, que popula el nombre
 *   del treatment). NO son los `ProgramPatient` (que es otra cosa).
 */
const patientProgramsService = {};

/**
 * @description Devuelve los protocolos del paciente, deduplicados por treatment,
 *              con nombre, descripción, estado y desde cuándo. Ordenados del más
 *              reciente al más antiguo.
 * @param {string} patientId - User._id del paciente
 * @returns {Promise<Array<{_id,name,description,status,since}>>}
 */
patientProgramsService.getMyPrograms = function (patientId) {
  return api
    .get(`/episodes/patients/${patientId}/`)
    .then((res) => {
      const docs =
        (res.data && res.data.docs) ||
        (Array.isArray(res.data) ? res.data : []);
      const byId = {};
      docs.forEach((ep) => {
        (ep.treatments || []).forEach((et) => {
          const tr = et.treatment;
          if (!tr || !tr._id) return;
          const id = String(tr._id);
          const since = et.createdAt || ep.createdAt;
          if (!byId[id] || new Date(since) > new Date(byId[id].since)) {
            byId[id] = {
              _id: id,
              name: tr.name,
              description: tr.description,
              status: ep.status === "active" ? "active" : ep.status || "active",
              since,
            };
          }
        });
      });
      return Object.values(byId).sort(
        (a, b) => new Date(b.since) - new Date(a.since)
      );
    })
    .catch(() => []);
};

export default patientProgramsService;
